import { SearchQueryProps } from '@/components/app/cards/ContentCard/types';

export function buildSearchQuery(packItemIndex: number): SearchQueryProps {
	return {
		query: '',
		filter_category: [],
		filter_duration: [],
		location: 'app' as const,
		pack_item_index: packItemIndex,
	};
}
